import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, Input } from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { ModalService } from "@root/router/index/modal.service";
import { CtripPriceFormService } from "./ctrip-price-form.service";
import _ from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";
import { SharedModule } from "@root/shared/shared.module";
import { ComponentModule } from "@root/component/component.module";
@Component({
  standalone: true,
  imports: [SharedModule, ComponentModule],
  selector: "host-ctrip-price-form",
  templateUrl: "./ctrip-price-form.component.html",
  styleUrls: ["./ctrip-price-form.component.scss"],
})
export class CtripPriceFormComponent implements OnInit {
  @ViewChild("ctripPriceTipModal", { static: true })
  ctripPriceTipModal: TemplateRef<any>;

  @Output() onClear = new EventEmitter();
  @Output() onConfirm = new EventEmitter();

  @Input() paymentType; // 0-预付 1-现付
  /**
   * 有两种情况：
   * 1，没有传卖价，卖价由底价和佣金计算得来
   * 2，传卖价，底价不需要本组件计算，上层调用者计算，然后传递过来即可
   */
  @Input() commission; // 佣金
  @Input() reservePrice; // 底价
  @Input()
  get salePrice() {
    return this._salePrice;
  }
  set salePrice(value) {
    if (_.isNil(value)) {
      /** 没传卖价 */
      this._salePrice = this.calculateSalePrice();
      // this._salePrice = value;
    } else {
      /** 传卖价，不需要计算底价，因为上层需要计算底价，所以干脆底价由上层传递过来 */
      this._salePrice = value;
      // this.reservePrice = this.calculateReservePrice();
    }
  }
  @Input() readonly commissionMin = 10;

  private _salePrice; // 卖价，初始时为空，由佣金和底价计算

  displayErrorText = false;

  constructor(
    private modalService: NzModalService,
    private globalModalService: ModalService,
    private ctripPriceFormService: CtripPriceFormService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {}

  exceedCommissionLimit() {
    return this.commission < this.commissionMin;
  }

  /** 佣金变化的时候，计算卖价 */
  onCommissionChange() {
    this._salePrice = this.calculateSalePrice();
  }

  /** 底价变化的时候，计算卖价 */
  onReservePriceChange() {
    this._salePrice = this.calculateSalePrice();
  }

  private calculateSalePrice() {
    return this.ctripPriceFormService.calculateSalePrice(this.commission, this.reservePrice);
  }

  // calculateReservePrice() {
  //   return this.ctripPriceFormService.calculateReservePrice(this.commission, this.salePrice);
  // }

  clear() {
    // this.commission = this.sellPrice = undefined;
    this.onClear.emit();
  }

  confirm() {
    if (this.exceedCommissionLimit()) {
      this.displayErrorText = true;
      return;
    }

    this.onConfirm.emit({
      commission: this.commission,
      reservePrice: this.reservePrice,
      salePrice: this.salePrice,
    });
    // this.onConfirm.emit({
    //   commission: this.commission,
    //   basePrice: this.basePrice,
    //   sellPrice: this.sellPrice
    // });
  }

  displayCtripPriceTipModal() {
    this.modalService.create({
      // nzTitle: "设置携程价格",
      nzTitle: this.translate.syncGet("ctrip.set_price"),
      nzContent: this.ctripPriceTipModal,
      nzFooter: null,
      nzWidth: 440,
    });
  }

  displayCustomerServiceModal() {
    // this.globalModalService.displayCustomerServiceModal();
    this.globalModalService.displayCustomerServiceClient();
  }
}
